import TextInputAuth from "components/TextInputAuth";
import React from "react";

type Props = {
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  isHelpEmail: any;
  helpTextEmail: any;
  firstName: string;
  setFirstName: React.Dispatch<React.SetStateAction<string>>;
  isHelpFirstName: any;
  helpTextFirstName: any;
  secondName: string;
  setSecondName: React.Dispatch<React.SetStateAction<string>>;
  isHelpSecondName: any;
  helpTextSecondName: any;
  checkEmail: (email: string, type: string) => void;
  disabled?: boolean;
  setIsEditingEmail: (isEditingEmail: boolean) => void;
};

const ChildInput: React.FC<Props> = ({
  email,
  setEmail,
  isHelpEmail,
  helpTextEmail,
  firstName,
  setFirstName,
  isHelpFirstName,
  helpTextFirstName,
  secondName,
  setSecondName,
  isHelpSecondName,
  helpTextSecondName,
  checkEmail,
  disabled,
  setIsEditingEmail,
}): JSX.Element => {
  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-col w-full">
        <div className="flex flex-row font-nunito font-normal text-xl text-black mb-1">
          Child
        </div>
        <div className="flex flex-row">
          <div className="flex flex-col w-1/3 mr-2">
            <TextInputAuth
              placeholder={"optional"}
              label="Email"
              value={email}
              onChange={(e: any) => {
                setIsEditingEmail(true);
                setEmail(e.target.value);
                const emailValue = e.target.value;
                if (
                  emailValue &&
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)
                ) {
                  checkEmail(emailValue, "child");
                }
              }}
              isHelp={isHelpEmail}
              helpText={helpTextEmail}
            />
          </div>
          <div className="flex flex-col w-1/3 mx-2">
            <TextInputAuth
              placeholder={"First Name"}
              label="First Name"
              value={firstName}
              onChange={(e: any) => setFirstName(e.target.value)}
              isHelp={isHelpFirstName}
              helpText={helpTextFirstName}
              disabled={disabled}
            />
          </div>
          <div className="flex flex-col w-1/3 ml-2">
            <TextInputAuth
              placeholder={"Last Name"}
              label="Last Name"
              value={secondName}
              onChange={(e: any) => setSecondName(e.target.value)}
              isHelp={isHelpSecondName}
              helpText={helpTextSecondName}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChildInput;
